import { render, staticRenderFns } from "./ProductPurchasesTab.vue?vue&type=template&id=37d55377&scoped=true&"
import script from "./ProductPurchasesTab.vue?vue&type=script&lang=js&"
export * from "./ProductPurchasesTab.vue?vue&type=script&lang=js&"
import style0 from "./ProductPurchasesTab.vue?vue&type=style&index=0&id=37d55377&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d55377",
  null
  
)

export default component.exports